import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';

const LOGO_SVG = "https://customer-assets.emergentagent.com/job_115f2a70-e012-4ed0-b268-01edb5a7f1fc/artifacts/m7pu0oom_upscalemedia-transformed-2.svg";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <img src={LOGO_SVG} alt="Caribbean Blue Moon" className="h-16 w-auto mb-4" />
            <p className="text-slate-400 text-sm leading-relaxed mb-3">
              A.S.D. Caribbean Blue Moon Dance School. Dove la danza incontra la gioia, l'estate e l'inclusione.
            </p>
            <div className="text-slate-500 text-xs space-y-1">
              <p>Sede Legale: Via Ambra 19, Grosseto</p>
              <p>P.IVA: 01770860532</p>
              <p>Email/PEC: caribbean.bluemoon2025@gmail.com</p>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading font-bold text-base mb-4 text-[#FFCA28]">Link Rapidi</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/" className="text-slate-400 hover:text-white transition-colors text-sm">Home</Link>
              <Link to="/shop" className="text-slate-400 hover:text-white transition-colors text-sm">Shop</Link>
              <Link to="/corsi" className="text-slate-400 hover:text-white transition-colors text-sm">I Nostri Corsi</Link>
              <Link to="/affitta-sala" className="text-slate-400 hover:text-white transition-colors text-sm">Affitta Sala</Link>
              <Link to="/corsi" className="text-slate-400 hover:text-white transition-colors text-sm">Prenota Lezione</Link>
            </div>
          </div>

          {/* Courses */}
          <div>
            <h4 className="font-heading font-bold text-base mb-4 text-[#FFCA28]">I Nostri Corsi</h4>
            <div className="flex flex-col gap-2.5">
              <span className="text-slate-400 text-sm">Baby Dance</span>
              <span className="text-slate-400 text-sm">Reggaeton</span>
              <span className="text-slate-400 text-sm">Hip Hop & Latino</span>
              <span className="text-slate-400 text-sm">Caraibico Agonistico</span>
              <span className="text-slate-400 text-sm">Breakdance</span>
              <span className="text-slate-400 text-sm">Tango Argentino</span>
              <span className="text-slate-400 text-sm">Ballo di Gruppo</span>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading font-bold text-base mb-4 text-[#FFCA28]">Contattaci</h4>
            <div className="flex flex-col gap-3">
              <a href="tel:3801599564" className="flex items-center gap-2 text-slate-400 hover:text-white transition-colors text-sm">
                <Phone size={16} className="text-[#FF7043]" /> 380 159 9564
              </a>
              <a href="mailto:caribbeanbluemoon2025@gmail.com" className="flex items-center gap-2 text-slate-400 hover:text-white transition-colors text-sm">
                <Mail size={16} className="text-[#FF7043]" /> caribbeanbluemoon2025@gmail.com
              </a>
              <div className="flex items-start gap-2 text-slate-400 text-sm">
                <MapPin size={16} className="text-[#FF7043] shrink-0 mt-0.5" />
                <div>
                  <p>Grosseto - Via Ambra 19</p>
                  <p>Follonica - Palestra Altroquando</p>
                  <p>Abbadia S.S. - Palestra Hatena</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-12 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-slate-500 text-xs">
            © {new Date().getFullYear()} A.S.D. Caribbean Blue Moon Dance School. Tutti i diritti riservati.
          </p>
          <div className="flex items-center gap-4">
            <Link to="/privacy" className="text-slate-500 hover:text-white text-xs transition-colors">Privacy Policy</Link>
            <Link to="/cookie-policy" className="text-slate-500 hover:text-white text-xs transition-colors">Cookie Policy</Link>
            <Link to="/condizioni-vendita" className="text-slate-500 hover:text-white text-xs transition-colors">Termini e Condizioni</Link>
          </div>
          <p className="text-slate-600 text-xs font-accent text-lg">
            Dance is Life
          </p>
        </div>
      </div>
    </footer>
  );
}
